export const AADHAAR_REGEX = /^[2-9]{1}[0-9]{11}$/;
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
